import Vue from 'vue'
import { VTooltip } from 'v-tooltip'

VTooltip.options.defaultOffset = 3

Vue.directive( 'tooltip', VTooltip )
